import { render } from "./WatchList.vue?vue&type=template&id=060b944d&scoped=true&lang=pug"
import script from "./WatchList.vue?vue&type=script&lang=js"
export * from "./WatchList.vue?vue&type=script&lang=js"

import "./WatchList.vue?vue&type=style&index=0&id=060b944d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060b944d"]])

export default __exports__